// PRD 16 LR16 (LR10 verdict L-A + U-B) — an account's personas in the Control Panel's Users (ADR-0012): Player and Parent, a
// product axis beside the role (a Tenis10 parent is still `role: player`). An account stored without personas — or an older
// API that doesn't send them — holds the schema's default player.
const PERSONAS = [
  ["player", "Player", "primary"],
  ["parent", "Parent", "info"],
]
const LABELS = Object.fromEntries(PERSONAS.map(([persona, label]) => [persona, label]))

/** The account's personas, in the page's order (player first). */
export const accountPersonas = account => {
  const held = PERSONAS.map(([persona]) => persona).filter(persona => Array.isArray(account?.personas) && account.personas.includes(persona))
  return held.length ? held : ["player"]
}
export const holdsPersona = (account, persona) => accountPersonas(account).includes(persona)
export const personaLabel = persona => LABELS[persona]
export const personaTone = persona => PERSONAS.find(([value]) => value === persona)[2]
/** „Player · Parent” */
export const personasText = account => accountPersonas(account).map(personaLabel).join(" · ")

// The list's „Persona” filter: the accounts whose personas are exactly the set (the API's `personas`).
export const personaFilterOptions = [
  { label: "Player", value: "player" },
  { label: "Parent", value: "parent" },
  { label: "Player + parent", value: "parent,player" },
]
export const personaFilterLabel = value => personaFilterOptions.find(option => option.value === value)?.label ?? value

export const childrenText = count => `${count} ${count === 1 ? "child" : "children"}`
